module.exports = __webpack_public_path__ + "img/annotation-key.40015bde.svg";